import { UpgradeMessage } from 'owa-locstrings/lib/strings/upgrademessage.locstring.json';
import loc from 'owa-localize';
import { observer } from 'mobx-react';
import * as React from 'react';

import { logUsage } from 'owa-analytics';
import { openPremiumDashboard } from 'owa-whats-new';
import HeaderCharm from './HeaderCharm';
import { ControlIcons } from 'owa-control-icons';

const styles = require('./Header.scss');

@observer
export default class PremiumOlkCharm extends React.Component<{}, {}> {
    componentDidMount() {
        logUsage('HeaderPremiumDiamondDisplayed');
    }

    render() {
        return (
            <HeaderCharm
                ariaLabel={loc(UpgradeMessage)}
                className={styles.launchManagePremium}
                title={loc(UpgradeMessage)}
                icons={{ iconName: ControlIcons.Diamond }}
                behavior={{
                    onClick: this.navigateTo,
                    isActive: false,
                }}
            />
        );
    }

    private navigateTo() {
        logUsage('HeaderPremiumDiamondClicked');
        openPremiumDashboard();
    }
}
